export interface PersonNameParts {
  first_name?: string | null;
  last_name?: string | null;
  patronymic_name?: string | null;
}

/**
 * Единый порядок отображения ФИО: имя, отчество, фамилия — как в живой речи
 * («Пётр Иванович Иванов»). Канцелярский порядок «Фамилия Имя Отчество» в UI не
 * используется: списки сортируются запросом, а не формой имени.
 * Отсутствующие части пропускаются, при полном отсутствии возвращается пустая строка.
 */
export const formatPersonName = (person: PersonNameParts): string =>
  [person.first_name, person.patronymic_name, person.last_name].filter(Boolean).join(' ');
